import { Popover } from 'antd';
import { TooltipRef } from 'antd/lib/tooltip';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';

import GantButtonListOfTask from '../../gantButtonListOfTask';

interface SinglePopoverProps {
    handleShowListTask: (itemId: string) => () => void;
}

export const ProjectsTreePopover = forwardRef(({ handleShowListTask }: SinglePopoverProps, ref) => {
    const [_, setRenderTrigger] = React.useState(0); // Used to force re-rendering
    const popRef = useRef<TooltipRef>(null);
    const markerRef = useRef<HTMLDivElement>(null);
    const openRef = useRef<boolean>(false);
    const itemIdRef = useRef<string>('');

    useImperativeHandle(ref, () => ({
        show: (itemId: string, anchor?: HTMLDivElement) => {
            if (!anchor) {
                return;
            }

            itemIdRef.current = itemId;

            setRenderTrigger((prev) => prev + 1);

            if (markerRef.current) {
                openRef.current = true;

                const marker = markerRef.current;
                marker.className = 'invisible-marker';
                marker.style.position = 'absolute';
                marker.style.right = '0';
                marker.style.top = '0';
                marker.style.height = '100%';
                marker.style.width = '1px';

                marker.style.pointerEvents = 'none';

                anchor.style.position = 'relative';

                anchor.appendChild(marker);
                popRef.current?.forceAlign();
            }
        },
        hide: () => {
            openRef.current = false;
            popRef.current?.forceAlign();

            setRenderTrigger((prev) => prev + 1);
        },
    }));

    return (
        <Popover
            ref={popRef}
            content={<GantButtonListOfTask onClick={handleShowListTask(itemIdRef.current)} />}
            placement="right"
            open={openRef.current}
        >
            <div ref={markerRef} style={{ visibility: 'hidden' }} />
        </Popover>
    );
});
